import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { from, of, forkJoin } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';
import { environment } from '@env/environment';

export const headersInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) =>
{
    const device$ = from(Device.getInfo()).pipe(catchError(() => of(null)));
    const app$ = from(App.getInfo()).pipe(catchError(() => of(null)));

    return forkJoin({ device: device$, app: app$ }).pipe(
        map(({ device, app }) =>
        {
            const headersToApply = [
                { key: 'Accept', value: 'application/json' },
                { key: 'X-Platform', value: Capacitor.getPlatform(), },
                { key: 'X-Version', value: environment.version, },
                ...(device ? [
                    { key: 'X-Device-Platform', value: device.platform, },
                    { key: 'X-Device-Model', value: device.model, },
                    { key: 'X-Device-OS-Version', value: device.osVersion, },
                    { key: 'X-Device-WebView-Version', value: device.webViewVersion, },
                    { key: 'X-Device-Manufacturer', value: device.manufacturer, },
                ] : []),
                ...(app ? [
                    { key: 'X-App-Version', value: app.version, },
                    { key: 'X-App-Build', value: app.build, },
                ] : []),
            ];

            const notApplicableValues: any[] = ['null', 'undefined', 'NaN', '', undefined, null];
            let requestHeaders = req.headers;

            for (const { key, value } of headersToApply)
            {
                if (!requestHeaders.has(key) && !notApplicableValues.includes(value))
                {
                    requestHeaders = requestHeaders.append(key, value);
                }
            }

            return req.clone({ headers: requestHeaders, });
        }),
        switchMap((clonedReq) => next(clonedReq)),
    );
};
